export default [
	//商机详情
	{
		path: 'businessDetail',
		name: 'businessDetail',
		component: () => import('@/views/crmManage/businessManage/businessDetail.vue'),
	},
]
